import React, { useState, useContext } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { uploadFile, fetchPromotions } from "../../api/promotions";
import { toast } from "../../helpers/smu-alerts/smu-lerts";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import SmuFileUploader from "../../utils/smu-file-uploader/SmuFileUploader";
import { StoreContext } from "../../store/StoreContext";

const acceptedTypes = ["TXT"];
const brand = process.env.REACT_APP_BRAND || "S10";

const LoadPromotions = () => {
  
  const { setPromotions } = useContext(StoreContext);
  const [files, setFiles] = useState([]);

  const handleUploadFile = () => {
    const formData = new FormData();
    const file = files[0];
    if (!file)
      return toast({
        icon: "error",
        title: "No fue posible cargar el archivo.",
      });

    formData.append("file", file, file.name);
    return uploadFile(formData)
      .catch((err) => {
        if (err?.response?.status === 400) {
          const msg = err?.response?.data?.message || "Verifique el archivo e intente nuevamente.";
          toast({
            icon: "error",
            title: "Estructura inválida",
            text: msg,
          });
        } else {
          toast({
            icon: "error",
            title: "No fue posible cargar el archivo.",
          });
        }
        return {error: true, type: 'promo'};
      })
      .finally(async () => {
        //Set promotions in Context after upload a new one
        const { data, error } = await fetchPromotions(brand, 333);
        if (error) return;
        setPromotions(data);
      });
  };

  return (
    <Card className="smu-card">
      <Card.Header className="d-flex flex-column py-4">
        <div className="d-flex align-items-center me-auto">
          <SmuBadge color="#B1E5FC" />
          <span className="fs-5 ms-3 me-auto">Cargar Promociones</span>
        </div>
      </Card.Header>
      <Card.Body className="d-flex flex-column">
        <Row>
          <Col col={12} lg={10} className="offset-lg-1">
            <SmuFileUploader
              uploadFile={handleUploadFile}
              acceptedTypes={acceptedTypes}
              files={files}
              setFiles={setFiles}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default LoadPromotions;
